import React from "react";
import { H1, H3 } from "@datapay-by-datacom/design-system";
import { Link } from "react-router-dom";
import { usePermissions } from "../../hooks";
import styles from "./OrgView.module.css";

interface OrgCategoryViewProps {
  title: string;
  category: string;
  children: (category: string) => React.ReactNode;
}

export function OrgCategoryView({
  title,
  category,
  children,
}: OrgCategoryViewProps) {
  const { isProvisioner } = usePermissions();

  return (
    <div className={styles.container}>
      <Link to="/org" className={styles.backLink}>
        &lt; Knowledge Bases
      </Link>
      <H1>{title}</H1>
      <div className={styles.orgHeader}>
        <H3>Category: {category}</H3>
        {isProvisioner() && (
          <span className={styles.roleLabel}>[Provisioner]</span>
        )}
      </div>

      {children(category)}
    </div>
  );
}
